import React, { useContext } from 'react';
import {
  APPLE_BUTTON_IMG_TEXT,
  APPLE_BUTTON_TEXT,
} from '../../../brands/default/content/components/checkout';
import { APPLE_BUTTON_IMG } from '../../../config/constants/images';
import ThemeContext from '../../../providers/ThemeProvider';

const AppleButton = () => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <img
        alt={APPLE_BUTTON_IMG_TEXT}
        className="apple"
        src={APPLE_BUTTON_IMG}
      />
      <span className="sr-only">{APPLE_BUTTON_TEXT}</span>

      <style jsx>{`
        .apple {
          width: 85%;
          padding: 5%;
        }
        @media (max-width: ${theme.breakpoints.xlDown}) {
          .apple {
            width: 90%;
            padding: 10px;
          }
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          .apple {
            width: 90%;
            padding: 15px;
          }
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .apple {
            width: 90%;
            padding: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default AppleButton;
